const BANK_TRACKING = {
  stride: {
    product_id: '6523',
    program_id: '609',
    bank_variant: 'stride',
  },
  bancorp: {
    product_id: '6216',
    program_id: '512',
    bank_variant: 'bancorp',
  },
};

export default BANK_TRACKING;
